
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/zippay",
      function () {
        return require("private-next-pages/zippay.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/zippay"])
      });
    }
  